import { render, staticRenderFns } from "./ChildRecord.vue?vue&type=template&id=b412f19e&scoped=true&"
import script from "./ChildRecord.vue?vue&type=script&lang=js&"
export * from "./ChildRecord.vue?vue&type=script&lang=js&"
import style0 from "./ChildRecord.vue?vue&type=style&index=0&id=b412f19e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b412f19e",
  null
  
)

export default component.exports